import React, { useEffect, useState, useRef, lazy } from 'react';
export function MobileImageCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/umd9RTX2VMgZXBdHQoQ62X/portada_30_recetas_para_bebes.png',
    alt: 'Portada - 30 Recetas para Bebés'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rQgdPf3Et8oJGGazmurZMR/1-mocup_%E2%80%9C30_RECETAS_PARA_BEBES%E2%80%9D.png',
    alt: 'Mockup digital en tablet'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/egw4Qy3eehZvS2oBmcJtf1/2-marketing_image.png',
    alt: 'Antes vs Después - Transformación'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1hu6wCYNN9paA2GZL2ZVeK/3-Collage_de_texturas.png',
    alt: 'Vista previa del contenido'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pYvG7ZzX5NEQYKNosLUE9N/4-texturas_seguras_para_bebes.png',
    alt: 'Guía de texturas seguras'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9wJi3MHGAToueriaqENNAt/4.1Baby_Food_Textures_Collage.png',
    alt: 'Collage de texturas por edad'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/q8YzhfYH4H3gu8Rf1MBocm/5-mom%E2%80%99s_and_baby%E2%80%99s.png',
    alt: 'Mamá feliz alimentando a su bebé'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hYoEZeFS7SssB62mDM1rWv/6-cualquier_super_de_Latinoamerica%E2%80%9D..png',
    alt: 'Ingredientes locales y accesibles'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hY5n8eQwaDfYSGsfk7HnTJ/7-Cozy_beige_infographic_steps.png',
    alt: 'Tres pasos simples'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nX6TCCizYvCg97RpAB9gkh/8-mama_mirando_a_camara_con_el_bebe_e.png',
    alt: 'Facilidad de uso en tu día a día'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ogvdD6nZvmB5KzB2VG5w28/9-mom_and_baby_scene_with_testimonial.png',
    alt: 'Testimonio real de mamás'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4ymZxPD3vTPXYcS6PQzKst/10-multi-device_warm_mockup_image.png',
    alt: 'Disponible en todos tus dispositivos'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/u3bqrHABE8co1aRrJ73M6v/promo_2.png',
    alt: 'Pack Bebé Bien Alimentado 7 en 1'
  }];
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    const handleScroll = () => {
      const scrollLeft = scrollContainer.scrollLeft;
      const slideWidth = scrollContainer.offsetWidth;
      const newSlide = Math.round(scrollLeft / slideWidth);
      setCurrentSlide(newSlide);
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => scrollContainer.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSlide = (index: number) => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;
    const slideWidth = scrollContainer.offsetWidth;
    scrollContainer.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth'
    });
  };
  return <section className="md:hidden py-8 sm:py-12 bg-gradient-to-br from-baby-cream to-baby-pink-light" data-id="element-695">
      <div className="px-4" data-id="element-696">
        <div className="text-center mb-6" data-id="element-697">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2" data-id="element-698">
            Explora el Contenido
          </h2>
          <p className="text-sm text-gray-600" data-id="element-699">
            Desliza para ver todo lo que incluye
          </p>
        </div>

        {/* Carousel Container */}
        <div className="relative" data-id="element-700">
          {/* Scroll Container */}
          <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-701">
            {images.map((image, index) => <div key={index} className="flex-shrink-0 w-full snap-center px-2" data-id="element-702">
                <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow border-2 border-baby-lavender bg-white" data-id="element-703">
                  <img src={image.url} alt={image.alt} className="w-full h-auto" loading="lazy" data-id="element-704" />
                </div>
              </div>)}
          </div>

          {/* Swipe Indicator - Only show on first slide */}
          {currentSlide === 0 && <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full text-xs font-medium animate-soft-pulse pointer-events-none" data-id="element-705">
              👈 Desliza para ver más
            </div>}
        </div>

        {/* Dots Navigation */}
        <div className="flex justify-center gap-2 mt-6" data-id="element-706">
          {images.map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`transition-all duration-300 rounded-full ${currentSlide === index ? 'w-8 h-2 bg-baby-gradient-pink-blue' : 'w-2 h-2 bg-gray-300'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-707" />)}
        </div>

        {/* Counter */}
        <div className="text-center mt-4" data-id="element-708">
          <p className="text-sm text-gray-600 font-medium" data-id="element-709">
            {currentSlide + 1} / {images.length}
          </p>
        </div>
      </div>

      <style jsx data-id="element-710">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>;
}